export interface NewsItem {
  id: string
  image: string
  date: string
  category: string
  titleKey: string
  excerptKey: string
  featured?: boolean
  external?: boolean
}

export const newsItems: NewsItem[] = [
  {
    id: 'top-italian-food-2026',
    image: '/images/top-italian-food-2026-premiazione-33Sito_Banner_PreviewNews_2788x984.jpg',
    date: '2026-03-15',
    category: 'Premi',
    titleKey: 'news.items.topItalian2026.title',
    excerptKey: 'news.items.topItalian2026.excerpt',
    featured: true,
  },
  {
    id: 'anuga-2025',
    image: '/images/Anuga2025-PreviewNews_2788x984.-v2jpg.jpg',
    date: '2025-10-08',
    category: 'Fiere',
    titleKey: 'news.items.anuga2025.title',
    excerptKey: 'news.items.anuga2025.excerpt',
    featured: true,
  },
  {
    id: 'top-italian-food-2025',
    image: '/images/top-italian-food-2025-premiazione-33Sito_Banner_PreviewNews_2788x984.jpg',
    date: '2025-03-20',
    category: 'Premi',
    titleKey: 'news.items.topItalian2025.title',
    excerptKey: 'news.items.topItalian2025.excerpt',
  },
  {
    id: 'estate-suprema',
    image: '/images/FRCC-EstateSuprema_Banner_Header_2788x984_A.png',
    date: '2025-06-15',
    category: 'Iniziative',
    titleKey: 'news.items.estateSuprema.title',
    excerptKey: 'news.items.estateSuprema.excerpt',
  },
  {
    id: 'nuovo-ad',
    image: '/images/Vladimir_Dukcevich_AD_CEO_Cesare_Fiorucci_SPA-news-desk.jpg',
    date: '2024-11-10',
    category: 'Azienda',
    titleKey: 'news.items.nuovoAd.title',
    excerptKey: 'news.items.nuovoAd.excerpt',
  },
  {
    id: 'mortadella-suprema',
    image: '/images/SUPREMA_news_1338x472_B_28-03-23.jpg',
    date: '2024-09-05',
    category: 'Prodotti',
    titleKey: 'news.items.mortadellaSuprema.title',
    excerptKey: 'news.items.mortadellaSuprema.excerpt',
  },
  {
    id: 'guanciale',
    image: '/images/Fiorucci_guanciale_1338x472.png',
    date: '2024-07-22',
    category: 'Prodotti',
    titleKey: 'news.items.guanciale.title',
    excerptKey: 'news.items.guanciale.excerpt',
  },
  {
    id: 'cosi-mi-piaci',
    image: '/images/COSI MI PIACI_news_1338x472_B_28-03-23.jpg',
    date: '2024-05-18',
    category: 'Campagne',
    titleKey: 'news.items.cosiMiPiaci.title',
    excerptKey: 'news.items.cosiMiPiaci.excerpt',
  },
  {
    id: 'bambin-gesu',
    image: '/images/preview-news-bambin-gesu-desktop.png',
    date: '2024-03-10',
    category: 'Solidarietà',
    titleKey: 'news.items.bambinGesu.title',
    excerptKey: 'news.items.bambinGesu.excerpt',
  },
]
